import { render, staticRenderFns } from "./ProjectDictList.vue?vue&type=template&id=9492b326&scoped=true"
import script from "./ProjectDictList.vue?vue&type=script&lang=js"
export * from "./ProjectDictList.vue?vue&type=script&lang=js"
import style0 from "./ProjectDictList.vue?vue&type=style&index=0&id=9492b326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9492b326",
  null
  
)

export default component.exports